import { render, staticRenderFns } from "./MonthPickerDual.vue?vue&type=template&id=8af2d1b0&scoped=true"
import script from "./MonthPickerDual.vue?vue&type=script&lang=js"
export * from "./MonthPickerDual.vue?vue&type=script&lang=js"
import style0 from "./MonthPickerDual.vue?vue&type=style&index=0&id=8af2d1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af2d1b0",
  null
  
)

export default component.exports